<template>
  <div class="big">
    <div class="page_title">医生标签管理</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              index="1"
              style="font-size:16px"
            >医生标签</el-menu-item>
            <el-menu-item
              index="2"
              style="font-size:16px"
            >医生筛选标签</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div class="component">
            <keep-alive>
              <component :is="currentComponent" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DoctorLabel from './DoctorLabel.vue';
import PickLabel from './PickLabel.vue';

export default {
  data() {
    return {
      activeIndex: '1',
      active: '1'
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return DoctorLabel;
        case '2':
          return PickLabel;
        default:
          return DoctorLabel;
      }
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.active = key;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
